"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShoppingProduct = exports.ShoppingCarousel = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
var _bricksTheme = _interopRequireDefault(require("@titelmedia/bricks-theme"));
var _reactSlick = _interopRequireDefault(require("react-slick"));
require("slick-carousel/slick/slick.css");
require("slick-carousel/slick/slick-theme.css");
var _chevron = _interopRequireDefault(require("./chevron.svg"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const NextArrow = (0, _react.forwardRef)((props, ref) => {
  const {
    onClick
  } = props;
  return _react.default.createElement(_styles.NextArrowEl, {
    onClick: onClick,
    ref: ref
  }, _react.default.createElement("img", {
    src: _chevron.default,
    alt: "Chevron"
  }));
});
const PrevArrow = (0, _react.forwardRef)((props, ref) => {
  const {
    onClick
  } = props;
  return _react.default.createElement(_styles.PrevArrowEl, {
    onClick: onClick,
    ref: ref
  }, _react.default.createElement("img", {
    src: _chevron.default,
    alt: "Chevron"
  }));
});
const ShoppingProduct = (0, _react.forwardRef)((props, ref) => {
  const {
    image,
    name,
    brand,
    price,
    url
  } = props;
  const fluid = image?.fluid || image?.responsiveImage || image;
  function content() {
    return _react.default.createElement(_styles.SliderItem, null, _react.default.createElement(_styles.ImageWrapper, null, _react.default.createElement(_styles.Image, {
      src: fluid?.src,
      ref: ref
    })), _react.default.createElement(_styles.TextWrapper, null, _react.default.createElement(_styles.Brand, null, brand), _react.default.createElement(_styles.Text, null, name), price && _react.default.createElement(_styles.Price, null, price)));
  }
  function showContent() {
    if (url) {
      return _react.default.createElement("a", {
        href: url,
        className: "shopping-carousel",
        target: "_blank",
        rel: "noreferrer"
      }, content());
    } else {
      return content();
    }
  }
  return _react.default.createElement("div", null, showContent());
});
exports.ShoppingProduct = ShoppingProduct;
const ShoppingCarousel = ({
  shoppingProducts,
  currency = 'EUR'
}) => {
  const country = currency === 'EUR' ? 'DE-de' : 'EN-us';
  let imageRef = (0, _react.useRef)(null);
  let previewArrowRef = (0, _react.useRef)(null);
  let nextArrowRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    setHeightArrows();
    window.addEventListener('resize', setHeightArrows);
    return () => {
      window.removeEventListener('resize', setHeightArrows);
    };
  }, []);
  const defaultSettings = {
    dots: false,
    arrows: true,
    infinite: shoppingProducts.length < 4 ? false : true,
    speed: 500,
    slidesToShow: shoppingProducts.length >= 3 ? 4 : 3,
    slidesToScroll: shoppingProducts.length >= 3 ? 4 : 3,
    touchThreshold: 13,
    centerPadding: 0,
    autoplay: false,
    prevArrow: _react.default.createElement(PrevArrow, {
      ref: previewArrowRef
    }),
    nextArrow: _react.default.createElement(NextArrow, {
      ref: nextArrowRef
    }),
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 2.5,
        slidesToScroll: 2,
        arrows: false,
        infinite: false
      }
    }, {
      breakpoint: 480,
      settings: {
        slidesToShow: 1.25,
        slidesToScroll: 1,
        arrows: false,
        infinite: false
      }
    }]
  };
  function setHeightArrows() {
    const height = Math.ceil(imageRef.current?.clientHeight / 2);
    if (imageRef.current && previewArrowRef.current && nextArrowRef.current) {
      previewArrowRef.current.style.top = `${height}px`;
      nextArrowRef.current.style.top = `${height}px`;
    }
  }
  function formatPrice(price) {
    if (price) {
      return new Intl.NumberFormat(country, {
        style: 'currency',
        currency
      }).format(price);
    }
    return '';
  }
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_bricksTheme.default, null), _react.default.createElement(_styles.Container, null, _react.default.createElement(_styles.SliderContainer, null, _react.default.createElement(_reactSlick.default, defaultSettings, shoppingProducts.map((shoppingProduct, index) => {
    return _react.default.createElement(ShoppingProduct, {
      key: `shopping-product--${index}`,
      ref: imageRef,
      url: shoppingProduct.url,
      image: shoppingProduct.image,
      price: formatPrice(shoppingProduct.price),
      name: shoppingProduct.name,
      brand: shoppingProduct.brand
    });
  })))));
};
exports.ShoppingCarousel = ShoppingCarousel;
//# sourceMappingURL=index.js.map